import React, { useEffect, useState } from 'react';
import QRCodeGenerator from './QRCodeGenerator';

const QRCodeModal = ({ syntax, networkName, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true); // Affiche le modal avec animation
  }, []);

  const handleClickOutside = (e) => {
    if (e.target.classList.contains('modal-overlay')) {
      setIsVisible(false);
      setTimeout(onClose, 300); // Ferme le modal après l'animation
    }
  };

  // Message à copier dans le format souhaité
  const messageToCopy = `${networkName} - ${syntax.title}\n\n${syntax.content}\n\n----------------------\n\nMerci d'utiliser EasySyntaxe !`;

  return (
    <div 
      className={`fixed inset-0 modal-overlay bg-black bg-opacity-70 flex items-center justify-center z-50 transition-opacity duration-300 ease-in-out ${isVisible ? 'opacity-100' : 'opacity-0'}`}
      onClick={handleClickOutside}
    >
      <div className={`bg-white p-6 rounded-lg shadow-lg transform transition-transform duration-300 ease-in-out ${isVisible ? 'translate-y-0 scale-100' : 'translate-y-4 scale-95'} max-w-sm w-full mx-4`}>
        <h2 className="text-lg font-bold mb-4 text-center">Scannez le code QR ci-dessous pour afficher la syntaxe</h2>
        <div className="flex justify-center mb-4">
          <QRCodeGenerator value={messageToCopy} /> {/* QR Code avec le message à copier */}
        </div>
        <p className="mt-4 text-center">Utilisez votre appareil pour scanner le QR Code.</p>
        <p className="text-sm text-gray-600 text-center">Le message va apparaitre sur votre écran.</p>
        
        {/* Barre de séparation */}
        <div className="my-4 border-t border-dashed border-gray-400"></div>

        <p className="text-sm text-gray-600 text-center mb-2">
          Merci d'utiliser EasySyntaxe ! Si vous avez des questions, n'hésitez pas à nous contacter.
        </p>
      </div>
    </div>
  );
};

export default QRCodeModal;
